import { api, ApiTags } from '../../api';
import { promptsActions } from '../../slices/prompts';
import { LikeRequest, LikeResponse } from './types';

const likesApi = api.injectEndpoints({
    endpoints: build => ({
        // Поставить/убрать лайк
        toggleLike: build.mutation<LikeResponse, LikeRequest>({
            query: ({ promptId, isLiked }) => ({
                url: '/like',
                method: 'POST',
                body: { promptId, isLiked },
            }),
            // Оптимистичное обновление через EntityAdapter
            onQueryStarted: async ({ promptId, isLiked }, { dispatch, queryFulfilled, getState }) => {
                const likeDelta = isLiked ? 1 : -1;

                // Получаем текущее состояние промпта для отката
                const state = getState() as any; // eslint-disable-line @typescript-eslint/no-explicit-any
                const currentPrompt = state.prompts.entities[promptId];
                const previousLikes = currentPrompt?.likes || 0;
                const previousIsLiked = currentPrompt?.isLiked || false;

                // Оптимистичное обновление в EntityAdapter
                dispatch(
                    promptsActions.updatePromptLikes({
                        id: promptId,
                        likes: previousLikes + likeDelta,
                        isLiked,
                    }),
                );

                try {
                    await queryFulfilled;
                } catch {
                    // Откатываем изменения при ошибке
                    dispatch(
                        promptsActions.updatePromptLikes({
                            id: promptId,
                            likes: previousLikes,
                            isLiked: previousIsLiked,
                        }),
                    );

                    // Инвалидируем промпт для перезагрузки актуальных данных
                    dispatch(api.util.invalidateTags([{ type: ApiTags.Prompts, id: promptId }]));
                }
            },
            // Не инвалидируем теги - используем только оптимистичные обновления через EntityAdapter
            invalidatesTags: [],
        }),
    }),
});

export const { useToggleLikeMutation } = likesApi;

export { likesApi };
